(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  if (!customElements.get('sn-article-toc')) {
    /**
     * Article table of contents: keeps the list open on wide screens, adds ids to
     * h2 headings that lack them, closes the panel after a jump on narrow screens,
     * and marks the section currently being read.
     */
    class SnArticleToc extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;
      /** @type {IntersectionObserver | null} */
      #observer = null;

      connectedCallback() {
        const details = this.querySelector('details');
        const body = this.dataset.body ? document.getElementById(this.dataset.body) : null;
        if (!(details instanceof HTMLDetailsElement) || !body) return;

        this.#controller = new AbortController();
        const { signal } = this.#controller;

        const headings = [...body.querySelectorAll('h2')];
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `sn-sec-${index + 1}`;
        });

        const wide = window.matchMedia('(min-width: 1100px)');
        const syncOpen = () => {
          if (wide.matches) details.open = true;
        };
        syncOpen();
        wide.addEventListener('change', syncOpen, { signal });

        details.querySelector('summary')?.addEventListener(
          'click',
          (event) => {
            if (wide.matches) event.preventDefault();
          },
          { signal }
        );

        this.addEventListener(
          'click',
          (event) => {
            const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
            if (link && !wide.matches) details.open = false;
          },
          { signal }
        );

        /** @type {Map<string, HTMLAnchorElement>} */
        const links = new Map();
        for (const link of this.querySelectorAll('a[href^="#"]')) {
          if (link instanceof HTMLAnchorElement) links.set(decodeURIComponent(link.hash.slice(1)), link);
        }
        const tracked = headings.filter((heading) => links.has(heading.id));
        if (!tracked.length || !('IntersectionObserver' in window)) return;

        /** @type {HTMLAnchorElement | null} */
        let current = null;
        const update = () => {
          const line = window.innerHeight * 0.3;
          let active = null;
          for (const heading of tracked) {
            if (heading.getBoundingClientRect().top <= line) active = heading;
            else break;
          }
          const link = active ? links.get(active.id) ?? null : null;
          if (link === current) return;
          current?.removeAttribute('aria-current');
          link?.setAttribute('aria-current', 'true');
          current = link;
        };

        this.#observer = new IntersectionObserver(update, { rootMargin: '0px 0px -70% 0px' });
        tracked.forEach((heading) => this.#observer?.observe(heading));
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        this.#observer?.disconnect();
        this.#observer = null;
      }
    }

    customElements.define('sn-article-toc', SnArticleToc);
  }

  if (!customElements.get('sn-article-share')) {
    /** Copies the article link and announces the result in the row's status region. */
    class SnArticleShare extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;
      #timer = 0;

      connectedCallback() {
        const button = this.querySelector('[data-copy]');
        const status = this.querySelector('[role="status"]');
        if (!(button instanceof HTMLButtonElement) || !status) return;

        this.#controller = new AbortController();
        button.addEventListener(
          'click',
          async () => {
            try {
              await navigator.clipboard.writeText(button.dataset.copy ?? window.location.href);
              button.dataset.copied = '';
              status.textContent = button.dataset.copiedLabel ?? '';
            } catch {
              status.textContent = button.dataset.errorLabel ?? '';
            }
            clearTimeout(this.#timer);
            this.#timer = window.setTimeout(() => {
              delete button.dataset.copied;
              status.textContent = '';
            }, 3000);
          },
          { signal: this.#controller.signal }
        );
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#controller = null;
        clearTimeout(this.#timer);
      }
    }

    customElements.define('sn-article-share', SnArticleShare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
